/**
 * Выбирает непересекающиеся подписи оси графика с учётом их видимой ширины.
 */
const AVG_CHARACTER_WIDTH = 6;
const LABEL_GAP = 8;

/** Приводит строковую или составную подпись графика к единому контракту. */
export function normalizeDashboardChartLabel(label) {
  if (typeof label === "string") {
    return { date: label, time: "" };
  }

  return {
    date: label?.date || "",
    time: label?.time || "",
  };
}

// Расстояние считается по видимой длине подписей, а не по количеству точек.
export function selectDashboardChartLabels(
  points,
  chartWidth,
  maxLabels = Infinity
) {
  if (chartWidth <= 0) return [];

  const selected = [];
  let previousRight = -Infinity;

  points.forEach((point) => {
    const label = normalizeDashboardChartLabel(point.label);
    const length = Math.max(label.date.length, label.time.length);
    if (!length) return;

    const halfWidth = (length * AVG_CHARACTER_WIDTH) / 2;
    const labelX = Math.max(
      halfWidth,
      Math.min(chartWidth - halfWidth, point.x)
    );
    const left = labelX - halfWidth;
    if (left < previousRight + LABEL_GAP) return;

    selected.push({ ...point, labelX });
    previousRight = labelX + halfWidth;
  });

  if (selected.length <= maxLabels) return selected;
  if (maxLabels <= 0) return [];
  if (maxLabels === 1) return [selected[0]];

  return Array.from({ length: maxLabels }, (_, index) => {
    const selectedIndex = Math.round(
      (index * (selected.length - 1)) / (maxLabels - 1)
    );
    return selected[selectedIndex];
  });
}
